<script lang="ts" setup>
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { onBeforeMount, ref } from "vue";
import { useStory } from "@/stores/story";
import MateStoryBookList from "@/components/mobile/story/story-book/MateStoryBookList.vue";
import CreateStoryBookGuide from "@/components/mobile/story/story-book/CreateStoryBookGuide.vue";
import { NoticeBar } from "vant";
import StoryMultiSelectionPopup from "@/components/mobile/story/story-book/StoryMultiSelectionPopup.vue";

// State
const createModalShow = ref(false);
const storyStore = useStory();
const showStoryImportPopup = ref(false);

onBeforeMount(async () => {
  await storyStore.getOrFetchStoryWithoutBookList();
});
// Lifecycle
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr]">
    <threads-nav
      :enable-switch-mate="false"
      :show-back="true"
      :show-center="false"
    >
      <template #right>
        <button
          class="btn btn-sm btn-primary rounded"
          @click="createModalShow = true"
        >
          {{ $t("Buttons.createStory") }}
        </button>
      </template>
    </threads-nav>
    <div class="h-full overflow-hidden">
      <notice-bar
        v-if="storyStore.storyWithoutBook.list.length > 0"
        :text="`${$t('story.storyHalf')} ${
          storyStore.storyWithoutBook.list.length
        } ${$t('story.storyFinal')}`"
        class="cursor-pointer"
        left-icon="volume-o"
        @click="showStoryImportPopup = true"
      />
      <mate-story-book-list />
    </div>
    <create-story-book-guide v-model:show="createModalShow" />
    <story-multi-selection-popup v-model:show="showStoryImportPopup" />
  </div>
</template>
